import { Posts } from "./posts/posts.js"
import { Single } from "./posts/single.js"

customElements.define("post-list", Posts)
customElements.define("single-post", Single)
